import pluralize from "pluralize"

const actions = {
  // GUEST LOBBY ERROR popups -------------------------------------------
  async errorEnteringGuestLobby({dispatch}) {
    dispatch('popups/show/error/custom', 'entering the Room lobby', {root: true})
  },
  // INVITES -------------------------------------------------------------------
  async successInvitingGuestsToRoom({dispatch}, [success, failed]) {
    let text = ''
    let icon = 'success'
    if (success.length && !failed.length) {
      text = `Successfully invited ${success.length} ${pluralize('user', success.length)}. <br></br> They should receive an email shortly.`
    } else if (success.length && failed.length) {
      text = `Successfully invited ${success.length} ${pluralize('user', success.length)}. <br></br> They should receive an email shortly.</br></br>
      However, ${failed.length} ${pluralize('user', failed.length)} already exists.`
    } else if (failed.length) {
      text = `These emails have already been added.`
      icon = 'error'
    }
    if(icon === 'success') {
      dispatch('popups/show/success', {
        message: text,
        timeout: 6000
      }, {root: true})
    } else {
      dispatch('popups/show/error', {
        message: text
      }, {root: true})
    }
  },

  async confirmTurnOffGuestLobby({dispatch}, [cancelCallback, confirmCallback]) {
    dispatch('popups/show/confirm',{
      message: `Are you sure you want to turn off the room lobby for guests?`,
      description: 'This will mean that guest users with the link will be able to join the room without being accepted. <br></br> The room password will also be disabled.',
      buttons: [
        {
          name: 'Cancel',
          id: 'back',
          function: () => {
            dispatch('popups/close', null, {root: true})
            cancelCallback
          }
        },
        {
          name: 'Turn off Lobby & Password',
          id: 'save',
          function: confirmCallback,
          colour: 'green'
        }
      ]
    }, {root: true})
  },

  // accept/reject from room lobby
  async successUpdateRoomLobbyGuestAccess({dispatch}, type) {
    dispatch('popups/show/success',{
      message: `Successfully ${type} this guest user. <br> ${type === 'accepted' ? 'They will be able to join the room shortly.' : 'They will not be able to enter this room.'}`
    }, {root: true})
  },
  async errorUpdateRoomLobbyGuestAccess({dispatch}, type) {
    dispatch('popups/show/error/custom', `${type} this guest user`, {root: true})
  },

  //SPACE GUEST
  async successInvitingGuestsToSpace({dispatch}, [success, failed]) {
    let text = ''
    let icon = 'success'
    if (success.length && !failed.length) {
      text = `Successfully invited ${success.length} ${pluralize('user', success.length)}. <br></br> They should receive an email shortly.`
    } else if (success.length && failed.length) {
      text = `Successfully invited ${success.length} ${pluralize('user', success.length)}. <br></br> They should receive an email shortly.</br></br>
      However, ${failed.length} ${pluralize('user', failed.length)} already exists.`
    } else if (failed.length) {
      text = `These emails have already been added.`
      icon = 'error'
    }

    if(icon === 'success') {
      dispatch('popups/show/success', {
        message: text,
        timeout: 6000
      }, {root: true})
    } else {
      dispatch('popups/show/error', {
        message: text
      }, {root: true})
    }
  },
};

export default {
  namespaced: true,
  actions
};
